/**
 * Login/Registration Routes
 *
 * Registration is now nested under journey context:
 * - /journey/:journeyId/:referral/register/:submissionId? - Register for a journey
 */

// Route name constants
export const LOGIN_ROUTE_NAMES = {
   REGISTER: 'register',
} as const;

/**
 * Parse the old referral param format
 */
function parseReferralParam(referralParam: string): { referral: string; query: Record<string, string> } {
   if (!referralParam) return { referral: '', query: {} };

   const parts = referralParam.split('~');

   if (parts[0] === 'preview' && parts.length >= 2) {
      return {
         referral: 'preview',
         query: {
            preview: parts[1],
            ...(parts[2] ? { lang: parts[2] } : {}),
         },
      };
   }

   return { referral: referralParam, query: {} };
}

/**
 * Extract the actual journey ID from the old format (name~id or just id)
 */
function extractJourneyId(id: string): string {
   if (!id) return '';
   return id.includes('~') ? id.split('~').pop() || id : id;
}

const loginRoutes = [
   // New clean registration route (nested under journey)
   {
      path: '/journey/:journeyId/:referral/register/:submissionId?',
      name: LOGIN_ROUTE_NAMES.REGISTER,
      component: () => import('@/modules/login/pages/register.vue'),
      meta: { title: 'Register' },
   },

   // Legacy redirect: old registration route → new route
   {
      path: '/register/:id/:referral/:submission_id?',
      redirect: (to: any) => {
         const journeyId = extractJourneyId(to.params.id);
         const { referral, query } = parseReferralParam(to.params.referral);
         return {
            name: LOGIN_ROUTE_NAMES.REGISTER,
            params: {
               journeyId,
               referral,
               submissionId: to.params.submission_id,
            },
            query: { ...to.query, ...query },
         };
      },
   },
];

export default loginRoutes;

